import { Message } from '../../message';
export const MESSAGES_EN_LANG = 'en-EN';
export const MESSAGES_EN_US_LANG = 'en-US';
export const MESSAGES_EN_NAV = 'en';

export const MESSAGES_EN = [new Message('', '')];
